import React, { useMemo } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useHistory } from "react-router";
import { useGlobalContext } from "../../../services/context/globalContext";
import arrowIcon from "../../../assets/icons/arrow_right.svg";

interface Workshop {
  _id: string;
  workshop_name: string;
  address: string;
  discounted_workshop_price: string;
  percentage_saved: number;
}

interface ListConditionalShopsProps {
  workshopsData: Workshop[];
  isPricingVisible: boolean;
}

const ListConditionalShops: React.FC<ListConditionalShopsProps> = ({
  workshopsData,
  isPricingVisible,
}) => {
  const { setDistance } = useGlobalContext();

  const history = useHistory();

  const sortedToLowToHighWorkshops = useMemo(
    () =>
      [...workshopsData].sort(
        (a, b) =>
          parseFloat(a.discounted_workshop_price) -
          parseFloat(b.discounted_workshop_price),
      ),
    [workshopsData],
  );

  return (
    <Box
      sx={{
        overflowY: "auto",
        height: "100vh",
        pb: "100px",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "&-ms-overflow-style:": {
          display: "none",
        },
      }}
    >
      {sortedToLowToHighWorkshops.map((elem: any) => (
        <Button
          key={elem._id}
          fullWidth
          onClick={(event) => {
            event.preventDefault();
            setDistance("dummy distance");

            //history.push(`/workshop-result/${elem._id}`);
            history.push(`/workshop-conditional-result/${elem._id}`);
          }}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(225, 235, 255, 1)",
            mb: "5px",
          }}
        >
          <Box sx={{ width: "40%" }}>
            <Box>
              <Typography
                textAlign={"start"}
                sx={{
                  color: "#002064",
                  fontWeight: "600",
                  fontSize: "16px",
                  textTransform: "capitalize",
                }}
              ></Typography>
            </Box>
            <Box>
              <Box>
                <Typography
                  textAlign={"start"}
                  sx={{
                    color: "rgba(0, 32, 100, 0.70)",
                    fontWeight: "bold",
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  {elem.workshop_name}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box>
                <Typography
                  textAlign={"start"}
                  sx={{
                    color: "rgba(0, 32, 100, 0.70)",
                    fontWeight: "500",
                    fontSize: "16px",
                    textTransform: "capitalize",
                  }}
                >
                  {elem.address}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box>
            <Box
              sx={{
                display: isPricingVisible ? "flex" : "none",
                flexDirection: "column",
              }}
            >
              <Button
                fullWidth
                sx={{
                  display: "flex",
                  alignSelf: "start",
                  textAlign: "start",
                  backgroundColor: "#E1EBFF",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#002064",
                  }}
                >
                  {`R${elem.discounted_workshop_price}`}
                </Typography>
                <Box>
                  <img
                    src={arrowIcon}
                    alt="/"
                    style={{
                      display: "flex",
                      alignSelf: "center",
                    }}
                  />
                </Box>
              </Button>
              {elem.percentage_saved > 0 && (
                <Button
                  fullWidth
                  sx={{
                    display: "flex",
                    alignSelf: "start",
                    textAlign: "start",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#00C88C",
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "capitalize",
                    }}
                  >
                    <strong>Save &nbsp;</strong>
                    {`${elem.percentage_saved}%`}
                  </Typography>
                </Button>
              )}
            </Box>
          </Box>
        </Button>
      ))}
    </Box>
  );
};

export default ListConditionalShops;
